import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CreditWorthinessIcon } from "../../assets/icons/CreditWorthinessIcon.js";
import "react/jsx-runtime";
const statusColorMap = (theme) => ({
  CREDITWORTHY: theme.palette.success[500],
  NOT_CREDITWORTHY: theme.palette.error[500],
  CHECK_IN_PROGRESS: theme.palette.secondary[500],
  EXPIRED: theme.palette.grey[600],
  NOT_APPLICABLE_LACK_OF_DATA: theme.palette.grey[600],
  NOT_APPLICABLE_CLINIC: theme.palette.grey[600],
  NOT_APPLICABLE_CHILD_PATIENT: theme.palette.grey[600],
  NOT_APPLICABLE_LACK_OF_CONSENT: theme.palette.grey[600],
  UNKNOWN: theme.palette.grey[600]
});
const StyledCreditWorthinessIcon = styled(CreditWorthinessIcon, {
  shouldForwardProp: (prop) => prop !== "status"
})(({ theme, status }) => ({
  width: "16px !important",
  height: "17px !important",
  "& path": {
    fill: statusColorMap(theme)[status] ?? "inherit"
  }
}));
const iconButtonColorMap = (theme) => ({
  CREDITWORTHY: theme.palette.success[50],
  NOT_CREDITWORTHY: theme.palette.error[50],
  CHECK_IN_PROGRESS: theme.palette.secondary[50],
  EXPIRED: theme.palette.grey[100],
  NOT_APPLICABLE_LACK_OF_DATA: theme.palette.grey[100],
  NOT_APPLICABLE_CLINIC: theme.palette.grey[100],
  NOT_APPLICABLE_CHILD_PATIENT: theme.palette.grey[100],
  NOT_APPLICABLE_LACK_OF_CONSENT: theme.palette.grey[100],
  UNKNOWN: theme.palette.grey[100]
});
const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "status"
})(({ theme, status }) => ({
  width: "24px",
  height: "24px",
  padding: 0,
  "&:hover": {
    backgroundColor: iconButtonColorMap(theme)[status] ?? "inherit"
  }
}));
export {
  StyledCreditWorthinessIcon,
  StyledIconButton
};
